import { Action, Dispatch } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { ApplicationState } from 'store'
import { addBusy, removeBusy } from 'store/busy'
import { LOGIN, LOGOUT, ProfileActionTypes } from './types'
import { APIRequest } from 'lynxapirequests'
import { AuthCookie } from '../../modules/AuthCookie'

const loginInternal = (authenticated: boolean): ProfileActionTypes => {
	return {
		type: LOGIN,
		payload: {
			authenticated
		}
	}
}

const logoutInternal = (): ProfileActionTypes => {
	return {
		type: LOGOUT
	}
}

export const logout = (): ThunkAction<void, ApplicationState, null, Action<string>> => async (dispatch): Promise<void> => {
	const isBlockingAction = true

	dispatch(addBusy(isBlockingAction))

	try {
		await APIRequest.User.logout()

		dispatch(
			logoutInternal()
		)

		dispatch(removeBusy(isBlockingAction))
	} catch (e) {
		console.error(e)
		dispatch(removeBusy(isBlockingAction))
	}
}

export const loginCookie = (): ThunkAction<Promise<string | void>, ApplicationState, null, Action<string>> => async (dispatch: Dispatch, getState: () => ApplicationState): Promise<string | void> => {
	const isBlockingAction = true

	dispatch(addBusy(isBlockingAction))

	try {
		const cookie = AuthCookie.get('lynxbridge', getState().config.ENVIRONMENT)
		if (!cookie || cookie === 'LOGGED_OUT') {
			dispatch(removeBusy(isBlockingAction))
			return ''
		}

		const tokens = atob(cookie).split(' ')

		if (tokens.length < 2) {
			console.error('token length error')
			dispatch(removeBusy(isBlockingAction))
			return ''
		}

		const accessToken = await APIRequest.User.renew({
			refreshToken: tokens[0],
			accessToken: tokens[1]
		})

		if (!accessToken) {
			console.error('access token was empty')
			dispatch(removeBusy(isBlockingAction))
			return ''
		}

		AuthCookie.create(getState().config.ENVIRONMENT, accessToken, tokens[0])

		APIRequest.setAuthorization(accessToken)

		dispatch(removeBusy(isBlockingAction))

		return ''
	} catch (e) {
		logout()(dispatch, getState, null)

		dispatch(removeBusy(isBlockingAction))

		return ''
	}
}
